import { useState } from "react";
import "./RegisterUser.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import { url } from "../../constants/url";
import { useAuth } from "../../Context/UserContext";


const RegisterUser = (props) => {
  const { setOpenRegUser, fetchRegisterUser } = props;

  const [switchUser, setSwitchUser] = useState("employee");
  const { logout, userRole, emailVer, isSidebarCollapsed } = useAuth('')

  const [employeeInputs, setEmployeeInputs] = useState(true)
  const [clientInputs, setClientInputs] = useState(false)

  const [employeeName, setEmployeeName] = useState('')
  const [employeeEmail, setEmployeeEmail] = useState('')
  const [clientName, setClientName] = useState('')
  const [userCompany, setUserCompany] = useState('')
  const [clientEmail, setClientEmail] = useState('')
  const [clientPermission, setClientPermission] = useState('')
  const [clientRole, setClientRole] = useState('')

  const [disableEmployeeButton, setDisableEmployeebutton] = useState(false)
  const [disableClientButton, setDisableClientbutton] = useState(false)

  const [employeeNameError, setEmployeeNameError] = useState('')
  const [employeeEmailError, setEmployeeEmailError] = useState('')
  const [clientNameError, setClientNameError] = useState('')
  const [clientEmailError, setClientEmailError] = useState('')
  const [clientPermissionError, setClientPermissionError] = useState('')
  const [clientRoleError, setClientRoleError] = useState('')
  const [userCompanyError, setUserCompanyError] = useState('')

  const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const capitalizedUserName = capitalizeFirstLetter(employeeName);
  const capitalizedClientName = capitalizeFirstLetter(clientName);
  const capitalizedClientCompany = capitalizeFirstLetter(userCompany);

  const nameRegex = /^[A-Za-z\s]+$/;

  const handleRegister = async () => {
    if (capitalizedUserName === '') {
      setEmployeeNameError("Employee name required")
      return
    }
    if (!nameRegex.test(capitalizedUserName)) {
      setEmployeeNameError("Name cannot contain special characters or numbers");
      return;
    }
    if (employeeEmail === '') {
      setEmployeeEmailError("Employee email required")
      return
    }
    if (!employeeEmail.endsWith('isecurion.com')) {
      setEmployeeEmailError("Invalid email")
      return
    }
    if (!validateEmail(employeeEmail)) {
      setEmployeeEmailError("Invalid email")
      return
    }
    try {
      const response = await fetch(`${url}/registeremployee`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          employeeName: capitalizedUserName,
          employeeEmail,
        })
      })
      if (response.ok) {
        toast.success('Employee registered successfully...', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        fetchRegisterUser()
        setEmployeeEmail('')
        setEmployeeName('')
        return
      }
      if (response.status === 302) {
        toast.error('Employee already exist...', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      if (response.status === 400) {
        toast.error("Bad Request", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });

      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });

      }

      return response

    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
        pauseOnHover: false,
      });

    }
  }


  // Refer users.js file for backend code
  const handleClientRegister = async () => {

    if (capitalizedClientCompany === '') {

      setUserCompanyError("Company name required")
      return
    }
    if (capitalizedClientName === '') {

      setClientNameError("Client name required")
      return
    }

    if (clientEmail === '') {

      setClientEmailError("Client email required")
      return
    }
    if (!validateEmail(clientEmail)) {
      setClientEmailError("Invalid email")

      return
    }
    if (clientEmail.toLowerCase().endsWith('@isecurion.com')) {
      setClientEmailError("Emails from isecurion.com are not allowed");

      return;
    }
    if (clientPermission === '') {

      setClientPermissionError("Permission required")
      return
    }
    if (clientRole === '') {

      setClientRoleError("Client role required")
      return
    }

    try {
      const response = await fetch(`${url}/registerclient`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          clientName: capitalizedClientName,
          clientEmail,
          clientRole,
          clientPermission,
          userCompany: capitalizedClientCompany
        })
      })
      if (response.ok) {
        toast.success('Client registered successfully...', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        fetchRegisterUser()
        setClientEmail('')
        setClientName('')
        setClientRole('')
        setUserCompany('')
        setClientPermission('')

        return
      }
      if (response.status === 302) {
        toast.error('Client already exist...', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });

      }
      if (response.status === 400) {
        toast.error("Invalid input", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });

      }

      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });

      }

      return response

    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
        pauseOnHover: false,
      });
      setDisableClientbutton(false)
    }
  }

  const handleRegisterPortal = () => {
    setOpenRegUser(false)

    setEmployeeName("")
    setEmployeeEmail("")

    setEmployeeNameError("")
    setEmployeeEmailError("")

    setClientName("")
    setClientEmail("")
    setClientRole("")
    setClientPermission("")
    setUserCompany("")

    setClientNameError("")
    setClientEmailError("")
    setClientRoleError("")
    setClientPermissionError("")
    setUserCompanyError("")
  }

  const handleEmployeeInputs = () => {
    setSwitchUser("employee")

    setClientInputs(false)
    setClientEmail('')
    setClientPermission("")
    setUserCompany('')
    setClientName('')
    setClientRole('')
    setUserCompanyError('')
    setClientEmailError('')
    setClientNameError('')
    setClientPermissionError("")
    setDisableClientbutton(false)
  }

  const handleClientInputs = () => {
    setSwitchUser("client")

    setClientInputs(true)
    setEmployeeEmail('')
    setEmployeeName('')
    setEmployeeEmailError('')
    setEmployeeNameError('')
    setDisableEmployeebutton(false)
  }


  return (
    <div className="isecurion_register_user_container">
      <div className="isecurion_register_user_form">
        <div className="isecurion_register_user_heading_container">
          <h2 className="isecurion_register_user_heading">Register User</h2>
          <button
            className="isecurion_register_user_close_button"
            onClick={handleRegisterPortal}
          >
            X
          </button>
        </div>

        <div className="isecurion_register_user_form_content">
          <div className="isecurion_register_user_description">
            <p>
              "Register the user by entering the required details. Upon
              successful registration, a confirmation email will be sent to the
              provided email address."
            </p>
          </div>

          <div className="isecurion_register_user_switch_user">
            <button
              onClick={handleEmployeeInputs}
              className={
                switchUser === "employee"
                  ? "isecurion_register_user_switch_user_active"
                  : ""
              }>
              <span>
                <Icon icon="carbon:person" width="19" height="19" />
                <span>Employee</span>
              </span>
            </button>
            <button
              onClick={handleClientInputs}
              className={
                switchUser === "client"
                  ? "isecurion_register_user_switch_user_active"
                  : ""
              }
            >
              <span>
                <Icon
                  icon="streamline-plump:office-worker"
                  width="19"
                  height="19"
                />
                <span>Client</span>
              </span>
            </button>
          </div>

          <div className="isecurion_register_user_form_fields">
            {switchUser === "employee" ? (
              <>
                <div className="isecurion_register_user_form_field">
                  <label>Employee Name</label>
                  <input type="text" placeholder="Enter employee name" value={employeeName} onChange={(e) => {
                    setEmployeeName(capitalizeFirstLetter(e.target.value))
                    setEmployeeNameError('')
                  }} />
                  {employeeNameError && <p>{employeeNameError}</p>}
                </div>
                <div className="isecurion_register_user_form_field">
                  <label>Employee Email</label>
                  <input type="email" placeholder="Enter employee email" value={employeeEmail} onChange={(e) => {
                    setEmployeeEmail(e.target.value)
                    setEmployeeEmailError('')
                  }} />
                  {employeeEmailError && <p>{employeeEmailError}</p>}
                </div>

                <div className="isecurion_register_user_form_submit">

                  <button onClick={handleRegister} >Register Employee</button>

                </div>
              </>
            ) : (
              <>
                <div className="isecurion_register_user_form_field">
                  <label>Company Name</label>
                  <input type="text" placeholder="Enter company name" value={userCompany} onChange={(e) => {
                    setUserCompany(capitalizeFirstLetter(e.target.value))
                    setUserCompanyError('')
                  }} />
                  {userCompanyError && <p>{userCompanyError}</p>}
                </div>
                <div className="isecurion_register_user_form_field">
                  <label>Name</label>
                  <input type="text" placeholder="Enter client name" value={clientName} onChange={(e) => {
                    setClientName(capitalizeFirstLetter(e.target.value))
                    setClientNameError('')
                  }} />
                  {clientNameError && <p>{clientNameError}</p>}
                </div>
                <div className="isecurion_register_user_form_field">
                  <label>Email</label>
                  <input type="email" placeholder="Enter client email" value={clientEmail} onChange={(e) => {
                    setClientEmail(e.target.value)
                    setClientEmailError('')
                  }} />
                  {clientEmailError && <p>{clientEmailError}</p>}
                </div>

                <div className="wrap_user_register_inputs">
                  <div className="isecurion_register_user_form_field">
                    <label>User Permission</label>
                    <div className="isecurion_register_user_custom-select-wrapper">
                      <select value={clientPermission} onChange={(e) => {
                        setClientPermission(e.target.value)
                        setClientPermissionError('')
                      }}>
                        <option value="">Select</option>
                        <option value="level 1">Executive Policy</option>
                        <option value="level 2">Manager Policy</option>
                        <option value="level 3">Lead Policy</option>
                        <option value="level 4">Engineer Policy</option>
                      </select>
                      <span className="isecurion_register_user_custom-select-arrow">
                        <Icon icon="ep:arrow-down" width="19" height="19" />
                      </span>
                    </div>
                    {clientPermissionError && <p>{clientPermissionError}</p>}
                  </div>
                  <div className="isecurion_register_user_form_field">
                    <label>User Role</label>
                    <input type="text" placeholder="Enter user role" onChange={(e) => {
                      setClientRole(e.target.value)
                      setClientRoleError('')
                    }} />
                    {clientRoleError && <p>{clientRoleError}</p>}
                  </div>
                </div>


                <div className="isecurion_register_user_form_submit">

                  <button onClick={handleClientRegister}>Register Client</button>

                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterUser;